/**
 * @desc 变更
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.CostCenterAddOrUpdateRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/costCenter/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
